function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.047 1.015a1.063 1.063 0 010 1.503L8.534 7.031l4.516 4.516a1.064 1.064 0 01-1.504 1.504L7.033 8.538l-4.511 4.511a1.063 1.063 0 11-1.503-1.502l4.512-4.512-4.513-4.512a1.064 1.064 0 011.504-1.504L7.035 5.53l4.512-4.512a1.063 1.063 0 011.504 0"
});

function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-full h-full fill-current"
  }, props), _ref);
}

export default SvgCross;